import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import en from 'element-ui/lib/locale/lang/en' // lang i18n
import '@/styles/index.scss' // global css
import App from './App'
import router from './router'

import '@/icons' // icon
import '@/permission' // permission control
import 'lib-flexible/flexible' // flexible
import '@/plugins/rem'

import head from '@/components/head'
import bottom from '@/components/bottom'
import carousel from '@/components/carousel/index'
import phoneMiddle from '@/components/phoneMiddle/phoneMiddle'
import phoneHead from '@/components/phoneHead'
import phoneNew from '@/components/phoneNew/phoneNew'
import downMenu from '@/components/downMenu'
import MetaInfo from 'vue-meta-info'

/* 首页页头*/
Vue.component('index_head', head)
/* 页头下拉菜单*/
Vue.component('down_menu', downMenu)
/* 首页页脚*/
Vue.component('index_bottom', bottom)
/* 轮播图*/
Vue.component('nav_carousel', carousel)
/* 手机首页*/
Vue.component('phoneMiddle', phoneMiddle)
/* 手机页头*/
Vue.component('phone_head', phoneHead)
// 手机新闻中心
Vue.component('phone_new', phoneNew)

// 设置使用en，默认配置中cn语言包依旧会引入
// Vue.use(ElementUI, { en })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)
// 时间格式化
Vue.use(require('vue-moment'))

Vue.use(MetaInfo)

// 开启警告
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  render: h => h(App)
}).$mount('#app')

// 加入百度统计
router.afterEach((to, from, next) => {
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?d54dc4be464f0dbcc8c885aa064fd8bd'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }, 1000)
})

/* 百度统计*/
/* <script>
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?d54dc4be464f0dbcc8c885aa064fd8bd";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
</script>*/
